import client from "./sharedoClient";

const getSchemaForType = async (graphType, type) => {
    const response = await client.get(`api/graph/${graphType}/schema/${type}`);
    if (response) {
        return response.data;
    }

    return null
}

const getSchemaForPaths = async (graphType, rootEntityType, paths) => {
    const request = {
        rootEntityType,
        paths
    };

    const response = await client.post(`api/graph/${graphType}/schema/path`, request);
    if (response) {
        return response.data;
    }
}

const querySchema = async (graphType, request) => {
    const response = await client.post(`/api/graph/${graphType}/schema/query`, request)
    if (response) {
        return response.data;
    }

    return null;
}

const getBudgetStructure = async systemName => client.get(`/api/graph/queries/budgetAmountQuery/${systemName}`);

const getRoleAspects = contextTypeSystemName => client.get(`/api/graph/queries/roleAspectQuery/${contextTypeSystemName}`)

const getDropDownItems = async endpoint => client.get(endpoint);

export default {
    getSchemaForType,
    getSchemaForPaths,
    querySchema,
    getDropDownItems,
    getBudgetStructure,
    getRoleAspects
}